module.exports = __webpack_public_path__ + "assets/img/eb7266f92ca3a75605374e49a4cca9e3.png";